/*
 * Front application entry point
 * Loads and mounts the main React app
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
// Removed global Flowbite theme wrapper per request
import Front from './react/views/Front';
import { installFetchRetryInterceptor } from './react/utils/fetchWithRetry';

// Retry global sur les 429 (rate limit nginx) pour tous les fetch de l'app
installFetchRetryInterceptor();

// Third-party CSS libraries (load first so Tailwind utilities can override)
import 'react-loading-skeleton/dist/skeleton.css';
import 'leaflet/dist/leaflet.css';

// Global CSS imports (load Tailwind after vendor CSS for proper override order)
import './styles/app.css';
import './styles/company-themes.css';

const container = document.getElementById('react-root');
if (container) {
    const root = createRoot(container);
    root.render(<Front />);
} else {
    console.error('React root element not found');
}
